import { render, staticRenderFns } from "./check-data.vue?vue&type=template&id=5d61969a&scoped=true&"
import script from "./check-data.vue?vue&type=script&lang=js&"
export * from "./check-data.vue?vue&type=script&lang=js&"
import style0 from "./check-data.vue?vue&type=style&index=0&id=5d61969a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d61969a",
  null
  
)

export default component.exports